import { render, staticRenderFns } from "./shopStoreDevice.vue?vue&type=template&id=0d454c23&"
import script from "./shopStoreDevice.vue?vue&type=script&lang=js&"
export * from "./shopStoreDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports